/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_System_QtyInputs */

const vi_stocktake_line_col_system_qty = /** @type {(inputs: Stocktake_Line_Col_System_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn hệ thống`)
};

/**

* @param {Stocktake_Line_Col_System_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_system_qty = /** @type {((inputs?: Stocktake_Line_Col_System_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_System_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_system_qty(inputs)
});